import * as React from 'react';
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";

import * as styles from './style.css';
import StoreButton from "../../../../uq-ui/components/store-button";
import StickersComponentsCommentsList from "../comments-list";

const EmptyComments = require('./img/empty-comments.png');
const EmptyComments2x = require('./img/empty-comments@2x.png');

class StickersComponentsStickerComments extends React.PureComponent {

  static propTypes = {
    comments: PropTypes.array,
    unreadCount: PropTypes.number,
    containerStyle: PropTypes.any
  };
  
  render() {
    const unreadStyles = {
      padding: String(this.props.unreadCount).length > 1 ? '0 3px' : null
    };

    return (
      <div className={styles.container} style={this.props.containerStyle}>
        <div className={styles.title}>
          {this.props.t('title')}
          { this.props.unreadCount > 0 && (
            <div className={styles.commentUnread} style={unreadStyles}>
              <div className={styles.commentUnreadCount}>{this.props.unreadCount}</div>
            </div>
          ) }
        </div>
        <div className={styles.inner}>
          {this.props.comments && this.props.comments.length > 0 && (
            <StickersComponentsCommentsList comments={this.props.comments} />
          )}
          <img src={EmptyComments} srcSet={EmptyComments2x} className={styles.icon} />
          <div className={styles.desc}>{this.props.t('description')}</div>
          {/*<StoreButton*/}
          {/*  containerClass={styles.link}/>*/}
        </div>
      </div>
    );
  }
}

export default withTranslation('cmp-sticker-comments')(StickersComponentsStickerComments);



// WEBPACK FOOTER //
// ./src/app/modules/stickers/ui/components/sticker-comments/index.jsx